export default {
  // Establecemos (actualizamos) los datos de configuración del usuario
  setUserData: (state, value) => (state.user = { ...state.user, ...value }),
  // Reseteamos los datos del usuario
  resetUserData: (state) => (state.user = null)
}
